import axios from 'axios'

const BASE_URL = import.meta.env.VITE_API_BASE_URL

export const postAuth = async (body) => {
  let config = {
    withCredentials: true,
  }

  // console.log('postAuth BASE_URL', BASE_URL)

  return await axios
    .post(`${BASE_URL}auth/login`, body, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        //window.localStorage.clear()
        // window.location.reload()
      }
      console.log('error postAuth', error.response.data)
      return error
    })
}

export const postAuthCode = async (code) => {
  const body = { code }

  const config = {
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
    },
  }

  try {
    const response = await axios.post(
      `${BASE_URL}auth/login-code`,
      body,
      config
    )
    return {
      data: response.data,
      responseStatus: response.status,
    }
  } catch (error) {
    if (error.response?.status === 401) {
      // window.localStorage.clear();
      // window.location.reload();
    }
    console.log('error postAuthCode', error.response?.data || error.message)
    return error
  }
}

export const postAuthGoogle = async (body) => {
  const config = {
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
    },
  }

  try {
    const response = await axios.post(`${BASE_URL}auth/login-google`, body, config)
    return {
      data: response.data,
      responseStatus: response.status,
    }
  } catch (error) {
    if (error.response?.status === 401) {
      window.localStorage.clear();
      // window.location.reload();
    }
    console.log('error postAuthGoogle', error.response?.data || error.message)
    return error
  }
}

export const postAuthRegisterGoogle = async (body) => {
  const config = {
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
    },
  }

  try {
    const response = await axios.post(`${BASE_URL}auth/login-register-google`, body, config)
    return {
      data: response.data,
      responseStatus: response.status,
    }
  } catch (error) {
    if (error.response?.status === 401) {
      //window.localStorage.clear()
      // window.location.reload()
    }
    console.log('error postAuthRegisterGoogle', error.response?.data || error.message)
    return error
  }
}

export const postComparePassword = async (body) => {
  const STORAGE_TOKEN = JSON.parse(window.localStorage.getItem('token'))
  let config = {
    headers: {
      Authorization: 'Bearer ' + STORAGE_TOKEN,
    },
    withCredentials: true,
  }

  // console.log('postAuth BASE_URL', BASE_URL)

  return await axios
    .post(`${BASE_URL}user-compare-password`, body, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error.response.status == 401) {
        // window.localStorage.clear()
        // window.location.reload()
      }
      console.log('error postAuth', error.response.data)
      return error
    })
}

export const postCheckUser = async (body) => {
  const STORAGE_TOKEN = JSON.parse(window.localStorage.getItem('token'))
  let config = {
    headers: {
      Authorization: 'Bearer ' + STORAGE_TOKEN,
    },
    withCredentials: true,
  }

  // console.log('postAuth BASE_URL', BASE_URL)

  return await axios
    .post(`${BASE_URL}auth/checkUsers`, body, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        // window.localStorage.clear()
        // window.location.reload()
      }
      console.log('error postAuth', error.response.data)
      return error
    })
}
export const postGuestComparePassword = async (body) => {
  let config = {
    withCredentials: true,
  }

  // console.log('postAuth BASE_URL', BASE_URL)

  return await axios
    .post(`${BASE_URL}user-guest-compare-password`, body, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        // window.localStorage.clear()
        // window.location.reload()
      }
      console.log('error postAuth', error.response.data)
      return error
    })
}
